module.exports = __webpack_public_path__ + "media/images/pages/ic-cancel-7474224adb6e856c8188151a0e9aa9b2.png";